import {Action} from '@ngrx/store';

import {Empresa} from './empresas.state';

export enum EmpresasActionTypes {
  EMPRESAS_LOAD_REQUEST = '[EMPRESAS] Load Request',
  EMPRESAS_LOAD_FAILURE = '[EMPRESAS] Load Failure',
  EMPRESAS_LOAD_SUCCESS = '[EMPRESAS] Load Success',
  EMPRESAS_REGISTRER_REDIRECT = '[EMPRESAS] Registrer Redirect',
  EMPRESAS_REGISTRER_FAILURE = '[EMPRESAS] Registrer Failure',
}

// load

export class EmpresasLoadRequestAction implements Action {
  readonly type = EmpresasActionTypes.EMPRESAS_LOAD_REQUEST;
}

export class EmpresasLoadFailureAction implements Action {
  readonly type = EmpresasActionTypes.EMPRESAS_LOAD_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class EmpresasLoadSuccessAction implements Action {
  readonly type = EmpresasActionTypes.EMPRESAS_LOAD_SUCCESS;

  constructor(public payload: { items: Empresa[] }) {
  }
}

// registrer in REUNE
export class EmpresasRegistrerRedirectAction implements Action {
  readonly type = EmpresasActionTypes.EMPRESAS_REGISTRER_REDIRECT;

  constructor(public payload: { item?: Empresa }) {
  }
}

export class EmpresasRegistrerFailureAction implements Action {
  readonly type = EmpresasActionTypes.EMPRESAS_REGISTRER_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

// actions

export type EmpresasActions =
  | EmpresasLoadRequestAction
  | EmpresasLoadFailureAction
  | EmpresasLoadSuccessAction
  | EmpresasRegistrerRedirectAction
  | EmpresasRegistrerFailureAction;
